import type { FormField } from '@cli-types/core-engine/schema.js'
export function sampleFormFieldValue(field: FormField): unknown {
  if (field.defaultValue !== undefined) {
    return field.defaultValue
  }

  if (field.options && field.options.length > 0) {
    const firstValue = field.options[0].value
    return field.type === 'multiselect' || field.type === 'checkbox' ? [firstValue] : firstValue
  }

  switch (field.type) {
    case 'email':
      return 'developer@example.com'
    case 'phone':
      return '+14155552671'
    case 'number':
      return 1
    case 'url':
      return 'https://example.com'
    case 'date':
      return '2026-01-01'
    case 'checkbox':
      return true
    case 'multiselect':
      return ['example']
    case 'file':
    case 'upload':
      return 'https://example.com/file.pdf'
    case 'timezone':
      return 'America/New_York'
    case 'list':
      if (field.fields && field.fields.length > 0) {
        return [
          Object.fromEntries(
            field.fields
              .filter((nestedField): nestedField is FormField & { name: string } =>
                Boolean(nestedField.name)
              )
              .map((nestedField) => [nestedField.name, sampleFormFieldValue(nestedField)])
          )
        ]
      }
      return ['Example item']
    default:
      return `Example ${field.label ?? field.name ?? 'value'}`
  }
}
